import React from 'react';
import { Box } from '@mui/material';
import VpsHero from './vps/VpsHero';
import VpsPricing from './vps/VpsPricing';
import WebsitePricing from './vps/WebsitePricing';
import VpsComparison from './vps/VpsComparison';
import VpsFeatures from './vps/VpsFeatures';
import VpsBuild from './vps/VpsBuild';
import VpsDeploy from './vps/VpsDeploy';
import VpsReviews from './vps/VpsReviews';
import VpsMigration from './vps/VpsMigration';
import VpsFaq from './vps/VpsFaq';

const HomePage = () => {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box sx={{ background: '#FFFFFF', minHeight: '100vh', fontFamily: '"Inter", sans-serif' }}>
      <VpsHero onGetStarted={scrollToPricing} />
      <VpsPricing />
      <WebsitePricing />
      <VpsComparison />
      <VpsFeatures />
      <VpsBuild />
      <VpsDeploy />
      <VpsReviews />
      <VpsMigration />
      <VpsFaq />
    </Box>
  );
};

export default HomePage;
